import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthoringModeService {

  authoringMode: boolean = null;

  constructor(private cookieService: CookieService) {}

  getAuthoringMode(): boolean {
    if (this.authoringMode === null) {
      this.detectAuthoringMode();
    }
    return this.authoringMode;
  }

  detectAuthoringMode(): void {
    const checkCookie: boolean = ['edit', 'preview'].includes(
      this.cookieService.get('wcmmode')
    );
    this.setAuthoringMode(checkCookie);
  }

  setAuthoringMode(isAuthoring: boolean) {
    this.authoringMode = isAuthoring;
  }
}
